module.exports = __webpack_public_path__ + "img/offers3.51b23f6f.webp";